import Dialog from "../../../components/Dialog";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import S from "../../../styles/pages/HistoryTach/AlertModal";

const { BtnPrimary } = ButtonStyles;

type AlertModalProps = {
    open: boolean;
    onClose: () => void;
};

const AlertModal = ({ open, onClose }: AlertModalProps) => {
    return (
        <Dialog openModal={open} onHide={onClose}>
            <S.StyledContainer>
                <span style={{ fontSize: "20px" }}>
                    Selecione pelo menos uma vigência.
                </span>
                <BtnPrimary onClick={onClose}>Ok</BtnPrimary>
            </S.StyledContainer>
        </Dialog>
    );
};

export default AlertModal;
